import React from 'react'
import useBrowserStorageCheck from '~/hooks/useBrowserStorageCheck'

import { Button, Flex, FocusTrap, Modal, Text } from '@mantine/core'

const StorageBoundaryModal = () => {
  const { isModalOpen, closeModal } = useBrowserStorageCheck()
  if (!isModalOpen) return null
  return (
    <Modal
      opened={isModalOpen}
      onClose={closeModal}
      title="Browser Storage Disabled 😢"
      centered
      withCloseButton={false}
      closeOnClickOutside={false}
      transitionProps={{ transition: 'fade', duration: 600, timingFunction: 'linear' }}
      closeOnEscape={false}
    >
      <FocusTrap.InitialFocus />
      <Text>
        Browser Storage is disabled or unsupported in your current browser. We recommend enabling it
        for a smoother experience. Please refresh the page once enabled.
      </Text>
      <Flex justify="flex-end" align="center" direction="row" wrap="wrap">
        <Button
          variant="filled"
          size="xs"
          onClick={() => window.location.reload()}
          style={{ margin: '10px 0' }}
        >
          Refresh Page
        </Button>
      </Flex>
    </Modal>
  )
}
export default StorageBoundaryModal
